/* eslint-disable indent */
// 默认值
import {homeworkAction} from '../action'
import defaultState, {HomeworkDefaultStateType} from '../state/homework'

type HomeworkActionType = keyof typeof homeworkAction

export type HomeworkStateType = {
	homework: HomeworkDefaultStateType
}

export default function homeworkReducer(
	state = defaultState,
	{type, payload}: {type: HomeworkActionType; payload: any}
) {
	switch (type) {
		case homeworkAction.UPDATE:
			return {
				...state,
				...payload
			}
		case homeworkAction.SET_MODE:
			return {
				...state,
				mode: payload
			}
		case homeworkAction.SET_MODE_DATA:
			return {
				...state,
				data: {
					...state.data,
					[state.mode]: {
						...state.data[state.mode],
						...payload
					}
				}
			}
		case homeworkAction.UPDATE_MODE_DATA:
			return {
				...state,
				data: payload
			}
		case homeworkAction.CHECK_UNIT_ID:
			return {
				...state,
				data: {
					...state.data,
					[state.mode]: {
						...state.data[state.mode],
						unit_id: payload
					}
				}
			}
		case homeworkAction.RESET_HOMEWORK_STORE:
			return defaultState

		case homeworkAction.SET_AREA_TREE:
			const {province_id, city_id, areaList} = payload

			let area_list = areaList
			if (province_id > 0) {
				if (city_id > 0) {
					// 区
					area_list = state.area_list.map((area: any) => {
						if (String(area.value) === String(province_id)) {
							area.children = area.children.map((child: any) => {
								if (String(child.value) === String(city_id)) {
									child.children = areaList
								}
								return child
							})
						}
						return area
					})
				} else {
					// 市
					area_list = state.area_list.map((area: any) => {
						if (String(area.value) === String(province_id)) {
							area.children = areaList
						}
						return area
					})
				}
			}
			return {
				...state,
				area_list
			}
		default:
			return state
	}
}
